import { render, staticRenderFns } from "./MyInfo.vue?vue&type=template&id=277c74d5&scoped=true"
import script from "./MyInfo.vue?vue&type=script&lang=js"
export * from "./MyInfo.vue?vue&type=script&lang=js"
import style0 from "./MyInfo.vue?vue&type=style&index=0&id=277c74d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277c74d5",
  null
  
)

export default component.exports